import { c as a } from "./index807.mjs";
var s = a, y = Array.isArray || function(r) {
  return s(r) === "Array";
};
export {
  y as i
};
